export const state = () => ({
    currentPage: 1,
    totalCount: null,
    fields: [],
    searchQuery: '',
    pageSize: 10

})

export const mutations = {
    SET_CURRENT_PAGE(state, payload) {
        state.currentPage = payload
    },
    SET_PAGE_SIZE(state, payload) {
        state.pageSize = payload
    },

    SET_TOTAL_COUNT(state, payload) {
        state.totalCount = payload
    },
    SET_FIELDS(state, payload) {
        state.fields = payload
    },
    SET_SEARCH_QUERY(state, payload) {
        state.searchQuery = payload
    },
    CLEAN_QUERIES(state) {
        state.searchQuery = ''
        state.fields = []
        state.currentPage = 1
        state.pageSize = 10
    },
}

export const actions = {
    setCurrentPage({ commit }, payload) {
        commit('SET_CURRENT_PAGE', payload)
    },
    setPageSize({ commit }, payload) {
        commit('SET_PAGE_SIZE', payload)
    },

    setTotalCount({ commit }, payload) {
        commit('SET_TOTAL_COUNT', payload)
    },
    setFields({ commit }, payload) {
        commit('SET_FIELDS', payload)
    },
    setSearchQuery({ commit }, payload) {
        commit('SET_SEARCH_QUERY', payload)
    },
    setCleanQueries({ commit }, payload) {
        commit('CLEAN_QUERIES', payload)
    },
}